import { FC } from "react";
import { Icon } from "../../../components/Icon/Icon";
import { colors } from "../../../styles/colors";
import useStyles from "./styles";

type ActionsTableProps = {
  handleEditSign?: () => void;
  handleDeleteSign?: () => void;
  handleManageServices?: () => void;
};

export const ActionsTable: FC<ActionsTableProps> = ({
  handleEditSign,
  handleDeleteSign,
  handleManageServices,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.divContainer}>
      <Icon
        name="pencil"
        color={colors.darkblack}
        height={"24px"}
        width={"24px"}
        style={{ cursor: "pointer" }}
        onClick={handleEditSign}
      />
      <Icon
        name="link" // Using link icon for services management
        color={colors.primary}
        height={"24px"}
        width={"24px"}
        style={{ cursor: "pointer", margin: "0 12px" }}
        onClick={handleManageServices}
      />
      <Icon
        name="trash"
        color={colors.red}
        height={"24px"}
        width={"24px"}
        onClick={handleDeleteSign}
        style={{ cursor: "pointer" }}
      />
    </div>
  );
};